import React from 'react'
import { DateText } from '../../../Global'

export const TableDataCellEndDate = ({ dataValue }: { dataValue?: string }) => {
  return <DateText value={dataValue} />
}
